//@ts-nocheck
import styles from './styles.module.scss';

const Spinner = ({ color = '#ffffff' }: { color?: string }) => {
  return <div className={styles.loader} style={{ '--color': color }} />;
};

export default Spinner;
